export enum AuditStreamType {
    OpenTelemetry = "OpenTelemetry",
    Splunk = "Splunk",
    SumoLogic = "Sumo Logic",
}
